import {parseChatRoute} from './chat-route.js';

type Owner = {id:string; workspace_id:string};
type Store = Pick<Storage,'getItem'|'setItem'|'removeItem'>;
const key = 'pm-chat:file-access-return';
function allowed(path:unknown,owner:Owner):path is string {
  return typeof path==='string' && path.length<=500 && !/[\\%?#\s]/.test(path)
    && !path.split('/').some(part=>part==='.'||part==='..') && parseChatRoute(path,owner.workspace_id)!==null;
}
// Only navigation context is saved. Authentication still uses the existing SSO
// flow; no token or session authority is saved or rebased here.
export function rememberFileAccessReturn(store:Store,owner:Owner,path:string,now=Date.now()):void {
  try {
    store.removeItem(key);
    if(allowed(path,owner))store.setItem(key,JSON.stringify({user:owner.id,workspace:owner.workspace_id,path,at:now}));
  } catch { /* Storage can be unavailable; sign-in must remain usable. */ }
}
export function takeFileAccessReturn(store:Store,owner:Owner,pathname:string,now=Date.now()):string|null {
  try {
    const raw=store.getItem(key);store.removeItem(key);
    if(!raw||pathname!=='/')return null;
    const value:unknown=JSON.parse(raw);
    if(!value||typeof value!=='object')return null;
    const saved=value as Record<string,unknown>;
    return saved.user===owner.id&&saved.workspace===owner.workspace_id
      &&typeof saved.at==='number'&&Number.isFinite(saved.at)&&saved.at<=now&&now-saved.at<=600_000
      &&allowed(saved.path,owner)?saved.path:null;
  } catch {return null;}
}
